
import {
  REQUEST_AGENCY_STUBS,
  RECEIVE_AGENCY_STUBS,
  SELECT_AGENCY_ID,
  INVALIDATE_AGENCY,
  REQUEST_AGENCY_STUBS_FAILURE
} from '../actions/agencyStubs'

const initialState = {
  isFetching: false,
  didInvalidate: false,
  selectedAgencyId: null,
  items: [],
  lastUpdated: null,
  error: null
};

const agencyStubs = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_AGENCY_STUBS:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
        error: null
      };
    case RECEIVE_AGENCY_STUBS:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.agencyStubs,
        lastUpdated: action.receivedAt
      };
    case REQUEST_AGENCY_STUBS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case INVALIDATE_AGENCY:
      return {
        ...state,
        didInvalidate: true,
        selectedAgencyId: null
      };
    case SELECT_AGENCY_ID:
      return {
        ...state,
        didInvalidate: false,
        selectedAgencyId: action.agencyId
      };
    default:
      return state;
  }
};

export default agencyStubs;
